import { Component, OnInit, OnDestroy } from '@angular/core';
import { IxellAPIService, IColorUserV1, Roles, ICtcV1 } from '../../tools/api.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Utils } from '../../tools/utils';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { StorageService } from '../../tools/storage.service';
import { Constants } from '../../entities/Constants';
import { Router } from '@angular/router';
import { HeaderService } from '../../tools/header.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
    selector: 'app-ManageColorUserV2',
    templateUrl: './manageColorUserV2.component.html',
    styleUrls: ['./manageColorUserV2.component.scss']
})
export class ManageColorUserV2 implements OnInit, OnDestroy {

    listOfBrands = [
        "Ixell",
        "Autocolor",
        "Cromax",
        "DeBeer",
        "Glasurit",
        "Lechler",
        "Lesonal",
        "Max Meyer",
        "PPG",
        "RM",
        "Sikkens",
        "Spie Hecker",
        "Standox",
        "Autre"
    ]

    displayedColumnsColorUser = ["firstName", "name", "mail", "sended", "action"];
    displayedColumns = ["companySocialReason", "address", "tva", "action"];

    isPreprod: boolean;
    isAdminLacour: boolean;
    infoPreprod: boolean = false;

    role: Roles;
    Roles = Roles;

    customersLst: IColorUserV1[] = [];
    editCustomersLst: IColorUserV1[] = [];
    customersSource: any;
    editCustomersSource: any;

    countries: any[] = [];
    noResults: boolean = false;
    emailExists: boolean = false;
    showOther: boolean = false;
    showOtherEdit: boolean = false;
    showMailForm: boolean = false;
    showCompanyForm: boolean = false;
    showListCompany: boolean = false;
    companySelected: any;
    companyEntered: IColorUserV1;
    dataCompanySelected: any;
    customerSelected: any;
    showVerifCompany: boolean = false;
    showCustomerCompany: boolean = false;
    showCustomerForm: boolean = false;
    newCustomer: boolean = false;
    mprRenault: boolean = false;
    mprRenaultOther: boolean = false;
    haveScale: boolean = false;
    editCurrentCompany: IColorUserV1;
    currentCustomer: IColorUserV1;
    otherCustomer: IColorUserV1;
    deleteMailCustomer: IColorUserV1;
    deleteAccountCustomer: IColorUserV1;
    country: string;
    regions: string[] = [];
    languages: any[] = [];
    mailCustomer: string;
    emergencyMailCustomer: string;
    validationModal: boolean = false;
    //envoiMailModal: boolean = false;
    openEditCustomerModal: boolean = false;
    openEditAddCustomerModal: boolean = false;
    confirmationDeleteAccount: boolean = false;
    confirmationDeleteMail: boolean = false;
    similarCustomers: IColorUserV1[];
    similarCompany: any[];
    isNewCompany: boolean = false;
    errorMsgMail: boolean = false;
    errorMsgCompany: boolean = false;
    errorMsgVerifCompany: boolean = false;
    errorMsgCustomer: boolean = false;
    msgConfirmation: boolean = false;
    ctcsFiltered: ICtcV1[] = [];
    checkedAnnuaire: boolean = false;
    annuaireIxell: boolean = false;

    //haveMailPrincipal: boolean = false;
    //checkBoxMailPrincipal: boolean = false;
    //haveMailSecondaire: boolean = false;
    //checkBoxMailSecondaire: boolean = false;
    changeMailPrincipal: string = "";
    haveChangeMailPrincipal: boolean = false;
    tmpCurrentCustomerMail: string = "";

    lastConnectionDate: string = "";
    availableCTCs: ICtcV1[] = [];

    mailUser: string = "";

    private searchCustomersSub: any;
    private checkMailSub: any;
    private saveAndSendIDSub: any;
    private saveSub: any;
    private regionsSub: any;
    private hiddeCustomerSub: any;
    private deleteDateMailSub: any;
    private getCustomerSub: any;
    private roleSub: any;
    private getSimilarCompanySub: any;
    private getCustomersCompanySub: any;
    private getCtcSub: any;
    private autoCoSub: any;
    private statsGetLastConnectionSub: any;
    private languageChangeSub: any;
    private getLstCtcByCountrySub: any;
    private getClientsByCompany: any;

    searchCustomerForm = new UntypedFormGroup({
        country: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        clientFilter: new UntypedFormControl('', [Validators.required]),
        clientOfId: new UntypedFormControl('')
    });

    editCompanyForm = new UntypedFormGroup({

        idColorUser: new UntypedFormControl('', [Validators.required]),

        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        siren: new UntypedFormControl(''),
        tva: new UntypedFormControl(''),

        businessCode: new UntypedFormControl(''),
        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),
        haveScale: new UntypedFormControl(''),
        paintBrand: new UntypedFormControl('')

    });

    editCustomerForm = new UntypedFormGroup({
        email: new UntypedFormControl('', Validators.compose([
            Validators.required,
            Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,}')
        ])),
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required]),

        isAdminIVC: new UntypedFormControl(''),
        isAdminIVL: new UntypedFormControl(''),
        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        businessCode: new UntypedFormControl(''),
        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),
        haveScale: new UntypedFormControl(''),
        paintBrand: new UntypedFormControl(''),

        siren: new UntypedFormControl(''),
        tva: new UntypedFormControl('')
    });

    addCustomerForm = new UntypedFormGroup({
        email: new UntypedFormControl('', Validators.compose([
            Validators.required,
            Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,}')
        ])),
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required]),

        isAdminIVC: new UntypedFormControl(''),
        isAdminIVL: new UntypedFormControl(''),
        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        businessCode: new UntypedFormControl(''),
        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),
        haveScale: new UntypedFormControl(''),
        paintBrand: new UntypedFormControl(''),

        siren: new UntypedFormControl(''),
        tva: new UntypedFormControl('')
    });

    otherCustomerForm = new UntypedFormGroup({
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required]),

        isAdminIVC: new UntypedFormControl(''),
        isAdminIVL: new UntypedFormControl(''),
        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        businessCode: new UntypedFormControl('', [Validators.required]),
        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),

        siren: new UntypedFormControl(''),
        tva: new UntypedFormControl('')
    });

    customerEmailForm = new UntypedFormGroup({
        email: new UntypedFormControl('', Validators.compose([
            Validators.required,
            Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,}')
        ]))
    });

    companyForm = new UntypedFormGroup({
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),

        siren: new UntypedFormControl(''),
        tva: new UntypedFormControl('')

    });

    similarCompanyForm = new UntypedFormGroup({
        similarCompany: new UntypedFormControl('', [Validators.required])
    });

    dataCompanyForm = new UntypedFormGroup({
        dataCompany: new UntypedFormControl('', [Validators.required])
    });

    customerCompanyForm = new UntypedFormGroup({
        customerCompany: new UntypedFormControl('', [Validators.required])
    });

    customerForm = new UntypedFormGroup({
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        language: new UntypedFormControl('', [Validators.required]),

        isAdminIVC: new UntypedFormControl(''),
        isAdminIVL: new UntypedFormControl(''),
        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        businessCode: new UntypedFormControl(''),
        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),
        haveScale: new UntypedFormControl(''),
        paintBrand: new UntypedFormControl('')
    });

    constructor(private headerService: HeaderService, private apiServices: IxellAPIService, private storage: StorageService, private router: Router, private translateService: TranslateService) { }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    changeCompanyFormCountryFacturation() {

        /*----------------------------------------------------------------------------------------------------*/console.log("changeCompanyFormCountryFacturation");

        if (this.companyForm.value["country"] != "" && this.companyForm.value["country"] != undefined) {
            var tvaRegEx = Constants.countries.find(c => c.name.toLowerCase() == this.companyForm.value["country"].toLowerCase()).tvaRegEx;
            if (tvaRegEx != "") {
                this.companyForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.companyForm.value["country"].toLowerCase()).tvaRegEx)]);
                this.companyForm.controls['tva'].updateValueAndValidity();
            } else {
                this.companyForm.controls['tva'].clearValidators();
                this.companyForm.controls['tva'].updateValueAndValidity();
                if (this.companyForm.value.tva != "") {
                    this.companyForm.controls["tva"].setValue("");
                }
            }
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    changeOtherCustomerFormCountryFacturation() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function changeOtherCustomerFormCountryFacturation");

        if (this.otherCustomerForm.value["country"] != "" && this.otherCustomerForm.value["country"] != undefined) {
            var tvaRegEx = Constants.countries.find(c => c.name.toLowerCase() == this.otherCustomerForm.value["country"].toLowerCase()).tvaRegEx;
            if (tvaRegEx != "") {
                this.otherCustomerForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.otherCustomerForm.value["country"].toLowerCase()).tvaRegEx)]);
                this.otherCustomerForm.controls['tva'].updateValueAndValidity();
            } else {
                this.otherCustomerForm.controls['tva'].clearValidators();
                this.otherCustomerForm.controls['tva'].updateValueAndValidity();
                if (this.otherCustomerForm.value.tva != "") {
                    this.otherCustomerForm.controls["tva"].setValue("");
                }
            }
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    changeEditCompanyFormCountryFacturation() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function changeEditCompanyFormCountryFacturation");

        if (this.editCompanyForm.value["country"] != "" && this.editCompanyForm.value["country"] != undefined) {
            var tvaRegEx = Constants.countries.find(c => c.name.toLowerCase() == this.editCompanyForm.value["country"].toLowerCase()).tvaRegEx;
            if (tvaRegEx != "") {
                this.editCompanyForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.editCompanyForm.value["country"].toLowerCase()).tvaRegEx)]);
                this.editCompanyForm.controls['tva'].updateValueAndValidity();
            } else {
                this.editCompanyForm.controls['tva'].clearValidators();
                this.editCompanyForm.controls['tva'].updateValueAndValidity();
                if (this.editCompanyForm.value.tva != "") {
                    this.editCompanyForm.controls["tva"].setValue("");
                }
            }
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    ngOnInit() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function ngOnInit");

        this.isPreprod = Utils.IsPreprod();

        this.headerService.changeCanBack(true);
        this.roleSub = this.headerService.currentRole.subscribe(role => {
            this.role = role;
            this.isAdminLacour = Utils.isAdminLacour(role);
        });
        this.headerService.changeTitle(this.translateService.instant('manageaccount.manageTitle'));

        /* recupération pays user et vérif qu'il a bien un pays */
        this.country = this.storage.get("country");
        if (this.country == "null") { this.country = ""; }

        /* recupération pays selon droits unisite (Admin ont droit a tous pays et autres à un seul pays) */
        if (Utils.isAdminRenault(this.role) || Utils.isAdminRenaultPays(this.role) || Utils.isAdminLacour(this.role)) {
            this.countries = Utils.countries();
        } else {
            this.countries = Utils.countriesFiltered(this.country);
        }
        if (this.country) {
            let cntry = this.countries.find(c => c.name.toLowerCase() == this.country.toLowerCase() || c.vo.toLowerCase() == this.country.toLowerCase()).name;
            this.searchCustomerForm.setValue({
                country: cntry,
                postalCode: "",
                clientFilter: 0,
                clientOfId: null
            });
            this.refreshCTCList(cntry);
            this.getRegions(false, "new", false);
        }
        this.languages = Utils.languages();
        if (!Utils.isAdminRenault(this.role) && !Utils.isAdminRenaultPays(this.role)) {
            this.searchCustomerForm.controls['country'].disable({ onlySelf: true });
        }

        var pays = this.searchCustomerForm.controls['country'].value;
        let country = this.countries.find(c => c.name.toLowerCase() == pays.toLowerCase() || c.vo.toLowerCase() == pays.toLowerCase()).name;
        if (country && country.toLowerCase() == "france") {
            this.annuaireIxell = true;
        } else {
            this.annuaireIxell = false;
            this.checkedAnnuaire = false;
        }

        if (Utils.isAdminLacour(this.role)) {
            this.displayedColumns = ["companySocialReason", "address", "tva", "mail", "action"];
            this.displayedColumnsColorUser.unshift("autoConnexion");
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    ngAfterViewInit() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function ngAfterViewInit");

        this.customerForm.valueChanges.subscribe(data => {
            if (this.msgConfirmation == true) this.msgConfirmation = false;
        });
        this.editCompanyForm.valueChanges.subscribe(data => {
            if (this.msgConfirmation == true) this.msgConfirmation = false;
        });
        this.editCustomerForm.valueChanges.subscribe(data => {
            if (this.msgConfirmation == true) this.msgConfirmation = false;
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayAnnuaire() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function displayAnnuaire");

        var pays = this.searchCustomerForm.controls['country'].value;
        let country = this.countries.find(c => c.name.toLowerCase() == pays.toLowerCase() || c.vo.toLowerCase() == pays.toLowerCase()).name;
        if (country && country.toLowerCase() == "france") {
            this.annuaireIxell = true;
        } else {
            this.annuaireIxell = false;
            this.checkedAnnuaire = false;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    displayModal(name: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function displayModal");

        let modal = document.getElementById(name);
        modal.style.display = "block";
        switch (name) {
            case 'new':
                this.editCompanyForm.markAsDirty();
                this.editCustomerForm.markAsDirty();
                this.showMailForm = true;
                this.errorMsgMail = false;
                this.companySelected = null;
                this.companyForm.reset();

                if (this.country) {
                    this.companyForm.controls["country"].setValue(this.countries.find(c => c.name.toLowerCase() == this.country.toLowerCase() || c.vo.toLowerCase() == this.country.toLowerCase()).name);
                }

                this.currentCustomer = new IColorUserV1();
                this.deleteMailCustomer = new IColorUserV1();
                this.deleteAccountCustomer = new IColorUserV1();
                this.otherCustomer = new IColorUserV1();

                break;
            case 'edit':
                break;
            case 'editCustomer':
                break;
            case 'editAddCustomer':
                this.addCustomerForm.reset();
                break;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    closeModalPreprod(name: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function closeModalPreprod");

        let modal = document.getElementById(name);
        modal.style.display = "none";
        this.infoPreprod = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    closeModalEditCustomer(name: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function closeModalPreprod");

        let modal = document.getElementById(name);
        modal.style.display = "none";
        this.openEditCustomerModal = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    closeModal(name: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function closeModal");

        let modal = document.getElementById(name);
        modal.style.display = "none";
        switch (name) {
            case 'new':
                this.similarCompanyForm.reset();
                this.dataCompanyForm.reset();
                this.customerForm.reset();
                this.customerEmailForm.reset();
                this.showCompanyForm = false;
                this.showListCompany = false;
                this.showVerifCompany = false;
                this.showCustomerCompany = false;
                this.showCustomerForm = false;
                this.errorMsgCompany = false;
                this.errorMsgVerifCompany = false;
                this.errorMsgCustomer = false;
                this.companySelected = null;
                this.dataCompanySelected = null;
                break;
            case 'edit':
                this.editCompanyForm.reset();
                this.editCustomerForm.reset();

                if (this.languageChangeSub != null) {
                    this.languageChangeSub.unsubscribe();
                    this.languageChangeSub = null;
                }
                if (this.statsGetLastConnectionSub != null) {
                    this.statsGetLastConnectionSub.unsubscribe();
                    this.statsGetLastConnectionSub = null;
                }

                break;
            case 'editCustomer':
                this.editCustomerForm.reset();
                break;
            case 'editAddCustomer':
                this.addCustomerForm.reset();
                break;
        }
        this.showOther = false;
        this.otherCustomerForm.reset();
        this.emailExists = false;
        this.newCustomer = false;
        if (this.validationModal)
            this.searchCustomer();
        this.validationModal = false;
        //this.envoiMailModal = false;
        this.haveScale = false;
        this.confirmationDeleteMail = false;
        this.confirmationDeleteAccount = false;
        this.newCustomer = false;
        this.msgConfirmation = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    closeModalEditAddCustomer(name: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function closeModalPreprod");
        let modal = document.getElementById(name);
        modal.style.display = "none";
        this.openEditAddCustomerModal = true;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    initLanguage() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function initLanguage");
        let language = this.storage.get("actualLanguage");
        this.customerForm.controls["language"].setValue(this.languages.find(c => c.code.toLowerCase() == language.toLowerCase()).name);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    refreshCTCList(country: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function refreshCTCList");
        let pays = this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name;
        this.getLstCtcByCountrySub = this.apiServices.getLstCtcByCountry(pays).subscribe(data => {
            this.availableCTCs = data.filter(ctc => isNaN(Number(ctc.name)));
            if (this.getLstCtcByCountrySub != null) this.getLstCtcByCountrySub.unsubscribe();
        },
            error => {
                this.availableCTCs = [];
                if (this.getLstCtcByCountrySub != null) this.getLstCtcByCountrySub.unsubscribe();
            });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    showAddUserModal() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function showAddUserModal");

        this.newCustomer = true;
        this.customerForm.controls['haveScale'].setValidators([Validators.required]);
        this.customerForm.controls['paintBrand'].setValidators([]);
        this.companyForm.setValue({
            socialReason: "",
            address: "",
            postalCode: "",
            city: "",
            country: this.country,
            siren: "",
            tva: ""
        });

        this.changeCompanyFormCountryFacturation();

        this.customerForm.setValue({
            name: "",
            firstName: "",
            mobile: "",
            phone: "",
            language: "",

            isAdminIVC: true,
            isAdminIVL: false,
            ctc: "",
            idCtc: 0,

            businessCode: this.regions.length == 1 ? this.regions[0] : '',
            customerNumber: "",
            customerCode: "",
            compteTresor: "",
            haveScale: false,
            paintBrand: ""
        });

        this.customerEmailForm.updateValueAndValidity();
        this.companyForm.updateValueAndValidity();
        this.customerForm.updateValueAndValidity();
        this.displayModal("new");
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param other
     * @param type
     * @param initCtc
     */
    getRegions(other: boolean, type: string, initCtc: boolean) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function getRegions");

        var customerForm;
        var companyCountry;
        switch (type) {
            case ('new'):
                customerForm = this.customerForm;
                companyCountry = this.companyForm.controls['country'].value;
                break;
            case ('edit'):
                customerForm = this.editCompanyForm;
                companyCountry = this.editCompanyForm.controls['country'].value;
                break;
        }

        if (companyCountry && (companyCountry.toLowerCase() == "france" || companyCountry.toLowerCase() == "spain" || companyCountry.toLowerCase() == "united kingdom")) {
            this.regionsSub = this.apiServices.getRegions(companyCountry).subscribe(data => {
                if (data) {
                    this.regions = data;
                }
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            });
        }

        if (companyCountry && (companyCountry.toLowerCase() == "france" || companyCountry.toLowerCase() == "spain" || companyCountry.toLowerCase() == "united kingdom")) {
            this.mprRenault = true;
            customerForm.controls['businessCode'].setValidators([Validators.required]);
            customerForm.controls['businessCode'].markAsTouched();
        }
        else {
            this.mprRenault = false;
            customerForm.controls['businessCode'].setValidators([]);
            customerForm.controls['businessCode'].markAsTouched();
        }

        if (this.otherCustomerForm.value.country && (this.otherCustomerForm.value.country.toLowerCase() == "france" || this.otherCustomerForm.value.country.toLowerCase() == "spain" || this.otherCustomerForm.value.country.toLowerCase() == "united kingdom")) {
            this.mprRenaultOther = true;
            this.otherCustomerForm.controls['businessCode'].setValidators([Validators.required]);
        }
        else {
            this.mprRenaultOther = false;
            this.otherCustomerForm.controls['businessCode'].setValidators([]);
        }
        this.otherCustomerForm.controls['businessCode'].updateValueAndValidity();
        customerForm.controls['businessCode'].updateValueAndValidity();

        if (initCtc) {
            this.loadCtcOfDrCustomer(type, "region");
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Ajout d'un nouvel utilisateur
     * */
    validMailForm() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function validMailForm");

        setTimeout(() => {
            if (this.emailExists == false) {
                if (this.customerEmailForm.valid) {
                    this.showCompanyForm = true;
                    this.showMailForm = false;
                }
                else {
                    this.customerEmailForm.markAllAsTouched();
                }
            }
        }, 500);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Formulaire Société
     * */
    searchSimilarCompany() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function searchSimilarCompany");

        if (this.companyForm.status == "VALID" && this.customerEmailForm.status == "VALID") {
            this.companyEntered = new IColorUserV1;
            this.companyEntered.socialReason = this.companyForm.controls['socialReason'].value;
            this.companyEntered.address = this.companyForm.controls['address'].value;
            this.companyEntered.postalCode = this.companyForm.controls['postalCode'].value;
            this.companyEntered.city = this.companyForm.controls['city'].value;
            this.companyEntered.country = this.companyForm.controls['country'].value;
            this.companyEntered.siren = this.companyForm.controls['siren'].value;
            this.companyEntered.tva = this.companyForm.controls['tva'].value;
            this.similarCustomers = [];
            this.similarCompany = [];
            this.companySelected = null;
            this.customerSelected = null;
            this.similarCompanyForm.controls['similarCompany'].reset();
            var pays = this.companyForm.controls['country'].value;
            let country = this.countries.find(c => c.name.toLowerCase() == pays.toLowerCase() || c.vo.toLowerCase() == pays.toLowerCase()).name;
            var postalCode = this.companyForm.value.postalCode;
            var city = this.companyForm.value.city;
            this.getSimilarCompanySub = this.apiServices.getSimilarCompany(country, postalCode, city).subscribe(data => {

                console.log(data);

                if (data.length > 0) {
                    this.showListCompany = true;
                    this.similarCompany = data;
                }
                else {
                    this.isNewCompany = true;
                    this.displayCustomerForm();
                    this.initLanguage();
                    this.newCustomer = true;
                }
                this.showMailForm = false;
                this.showCompanyForm = false;
                if (this.getSimilarCompanySub != null) this.getSimilarCompanySub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.getSimilarCompanySub != null) this.getSimilarCompanySub.unsubscribe();
            })
        }
        else {
            this.companyForm.markAllAsTouched();
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    returnToMailForm() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function returnToMailForm");

        this.showCompanyForm = false;
        this.showMailForm = true;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Liste des sociétés
     * @param value
     */
    chooseCompany(value: any) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function chooseCompany");

        if (this.companySelected != null && this.companySelected != value) {
            this.dataCompanyForm.reset();
            this.dataCompanySelected = null;
            this.customerCompanyForm.reset();
            this.customerSelected = null;
            this.customerForm.reset();
        }
        this.companySelected = value;
        this.errorMsgCompany = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    selectCompany() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function selectCompany");

        if (this.similarCompanyForm.status == 'VALID') {
            if (this.companySelected != null) {
                this.errorMsgCompany = false;
                this.showListCompany = false;
                if (this.companySelected == "new") {
                    this.isNewCompany = true;
                    this.showCustomerForm = true;
                    this.initLanguage();
                }
                else {
                    this.showVerifCompany = true;
                    this.isNewCompany = false;
                }
            }
        }
        else {
            this.similarCompanyForm.markAllAsTouched();
            this.errorMsgCompany = true;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayCompanyForm() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function displayCompanyForm");

        this.showCompanyForm = true;
        this.showListCompany = false;
        this.errorMsgCompany = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Vérification données société
     * @param value
     */
    selectInfosCompany(value: any) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function selectInfosCompany");

        this.dataCompanySelected = value;
        this.errorMsgVerifCompany = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayListCustomers() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function displayListCustomers");

        if (this.dataCompanyForm.status == 'VALID') {
            if (this.dataCompanySelected != null) {
                this.showVerifCompany = false;
                this.errorMsgVerifCompany = false;
                if (this.companySelected == "new") {
                    this.isNewCompany = true;
                    this.showCustomerForm = true;
                    this.initLanguage();
                    this.showListCompany = false;
                }
                else {
                    this.isNewCompany = false;
                    this.getCustomersCompanySub = this.apiServices.getListUsersById(this.companySelected.listIdcolorUser).subscribe(data => {
                        this.similarCustomers = data;
                        this.showCustomerCompany = true;
                        this.showListCompany = false;
                        if (this.getCustomersCompanySub != null) this.getCustomersCompanySub.unsubscribe();
                    }, error => {
                        console.log(error);
                        if (this.getCustomersCompanySub != null) this.getCustomersCompanySub.unsubscribe();
                    })
                }
            }
        }
        else {
            this.errorMsgVerifCompany = true;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayListCompany() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function displayListCompany");
        this.showVerifCompany = false;
        this.showListCompany = true;
        this.errorMsgVerifCompany = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Liste des utilisateurs de la société sélectionnée
     * @param value
     */
    select(value: any) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function select");
        this.customerSelected = value;
        this.errorMsgCustomer = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayCustomerForm() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function displayCustomerForm");

        var country = this.companyForm.controls['country'].value
        let pays = this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name;
        this.getCtcSub = this.apiServices.getLstCtcByCountryAndOrDR(pays, this.customerForm.value.businessCode).subscribe(data => {
            this.ctcsFiltered = data;
            if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        });

        if (this.similarCompany.length > 0) {
            if (this.customerCompanyForm.status == 'VALID') {
                this.customerForm.controls['paintBrand'].setValidators([]);
                this.customerForm.controls['haveScale'].setValidators([]);
                this.errorMsgCustomer = false;
                this.showCustomerForm = true;
                this.showCustomerCompany = false;
                if (this.country) {
                    this.companyForm.controls["country"].setValue(this.countries.find(c => c.name.toLowerCase() == this.country.toLowerCase() || c.vo.toLowerCase() == this.country.toLowerCase()).name);
                }
                let language = this.storage.get("actualLanguage");
                this.customerForm.controls["language"].setValue(this.languages.find(c => c.code.toLowerCase() == language.toLowerCase()).name);

                if (this.customerSelected != 'new' && this.customerSelected != null) {
                    this.customerForm.controls["name"].setValue(this.customerSelected.name);
                    this.customerForm.controls["firstName"].setValue(this.customerSelected.firstname);
                    this.customerForm.controls["mobile"].setValue(this.customerSelected.mobilePhone);
                    this.customerForm.controls["phone"].setValue(this.customerSelected.phone);
                    this.customerForm.controls["language"].setValue(this.customerSelected.language);

                    this.customerForm.controls["isAdminIVC"].setValue(this.customerSelected.isAdminIVC);
                    this.customerForm.controls["isAdminIVL"].setValue(this.customerSelected.isAdminIVL);
                    this.customerForm.controls["ctc"].setValue(this.customerSelected.ctc);
                    this.customerForm.controls["idCtc"].setValue(this.customerSelected.idCtc);

                    this.customerForm.controls["businessCode"].setValue(this.customerSelected.businessCode);
                    this.customerForm.controls["customerNumber"].setValue(this.customerSelected.mrpAccount);
                    this.customerForm.controls["customerCode"].setValue(this.customerSelected.customerCode);
                    this.customerForm.controls["compteTresor"].setValue(this.customerSelected.compteTresor);
                    this.newCustomer = false;
                }
                else if (this.customerSelected == 'new') {
                    this.newCustomer = true;
                    this.initLanguage();
                }
            }
            else {
                this.customerCompanyForm.markAllAsTouched();
                this.errorMsgCustomer = true;
            }
        }
        else {
            if (this.companyForm.status == 'VALID') {
                this.showCustomerForm = true;
            }
            else {
                this.companyForm.markAllAsTouched();
            }
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    displayVerifCompany() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function displayVerifCompany");
        this.showCustomerCompany = false;
        this.showVerifCompany = true;
        this.errorMsgCustomer = false;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Vue Formulaire Utilisateur
     * */
    getPreviousCustomerForm() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function getPreviousCustomerForm");
        this.showCustomerForm = false;
        this.customerForm.reset();
        if (this.companySelected != null) {
            if (this.companySelected == 'new') {
                this.showListCompany = true;
            }
            else {
                this.showCustomerCompany = true;
            }
        }
        else {
            this.showCompanyForm = true;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param bool
     */
    newCustomerHaveScale(bool: boolean) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function newCustomerHaveScale");
        let res: any;
        if (bool) {
            this.customerForm.controls['paintBrand'].setValidators([Validators.required]);
            res = 1;
        }
        else {
            this.customerForm.controls['paintBrand'].setValidators([]);
            res = 2;
        }

        this.haveScale = bool;
        this.customerForm.setValue({
            name: this.customerForm.value.name,
            firstName: this.customerForm.value.firstName,
            mobile: this.customerForm.value.mobile,
            phone: this.customerForm.value.phone,
            language: this.customerForm.value.language,

            isAdminIVC: this.customerForm.value.isAdminIVC,
            isAdminIVL: this.customerForm.value.isAdminIVL,
            ctc: this.customerForm.value.ctc,
            idCtc: this.customerForm.value.idCtc,

            businessCode: this.customerForm.value.businessCode,
            customerNumber: this.customerForm.value.customerNumber,
            customerCode: this.customerForm.value.customerCode,
            compteTresor: this.customerForm.value.compteTresor,
            haveScale: res,
            paintBrand: this.customerForm.value.paintBrand
        });

        this.customerForm.controls['paintBrand'].updateValueAndValidity();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    searchCustomer() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function searchCustomer");
        if (this.searchCustomerForm.valid) {
            let postalCode = this.searchCustomerForm.value.postalCode;
            var pays = this.searchCustomerForm.controls['country'].value;
            let country = this.countries.find(c => c.name.toLowerCase() == pays.toLowerCase() || c.vo.toLowerCase() == pays.toLowerCase()).name;
            let annuaireIxell = this.checkedAnnuaire;

            var clientFilter = this.searchCustomerForm.controls['clientFilter'].value;
            var clientOfId = this.searchCustomerForm.controls['clientOfId'].value;

            let ctcId = (clientFilter < 2) ? (clientFilter - 1) : (Number(clientOfId));

            this.searchCustomersSub = this.apiServices.getClientsByCountryAndPostalCodeAndIdCTC(country, postalCode, ctcId, annuaireIxell).subscribe(data => {

                console.log(data);

                if (data) {
                    this.customersSource = null;
                    this.customersLst = data;
                    if (this.customersLst.length > 0) {
                        this.noResults = false;
                        this.customersSource = new MatTableDataSource(this.customersLst.slice());
                    }
                    else {
                        this.noResults = true;
                    }
                }
                if (this.searchCustomersSub != null) this.searchCustomersSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.searchCustomersSub != null) this.searchCustomersSub.unsubscribe();
            });
        }
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Masquer
     * @param customer
     */
    openDeleteAccountModal(customer: IColorUserV1) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function openDeleteAccountModal");
        this.confirmationDeleteAccount = true;
        this.deleteAccountCustomer = customer;
        this.displayModal("confirmationDeleteAccountModal");
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    hiddeCustomer() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function hiddeCustomer");
        this.hiddeCustomerSub = this.apiServices.hiddeCustomer(this.deleteAccountCustomer.idcolorUser, "ManageColorUser").subscribe(data => {
            if (data) {
                this.searchCustomer();
                this.closeModal('confirmationDeleteAccountModal');
            }
        }, error => {
            console.log(error);
            if (this.hiddeCustomerSub != null) this.hiddeCustomerSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Supprimer la date d'envoi
     * @param customer
     */
    openDeleteMailModal(customer: IColorUserV1) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function openDeleteMailModal");
        this.confirmationDeleteMail = true;
        this.deleteMailCustomer = customer
        this.displayModal('confirmationDeleteMailModal');
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    deleteDateMail() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function deleteDateMail");
        this.deleteDateMailSub = this.apiServices.deleteDateMail(this.deleteMailCustomer.idcolorUser, "ManageColorUser").subscribe(data => {
            if (data) {
                this.searchCustomer();
                this.closeModal('confirmationDeleteMailModal');
            }
        }, error => {
            console.log(error);
            if (this.deleteDateMailSub != null) this.deleteDateMailSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Modale Editer
     * @param customer
     */
    editCustomer(customer: IColorUserV1) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function editCustomer");
        /*----------------------------------------------------------------------------------------------------*/console.log("customer", customer);
       
        this.editCompanyForm.controls['haveScale'].setValidators([]);
        this.editCompanyForm.controls['paintBrand'].setValidators([]);
        this.currentCustomer = customer;
        let tmpCountry: any = this.countries.find(c => c.name.toLowerCase() == this.currentCustomer.country.toLowerCase() || c.vo.toLowerCase() == this.currentCustomer.country.toLowerCase());
        if (tmpCountry) {
            tmpCountry = tmpCountry.name;
        } else {
            tmpCountry = this.currentCustomer.country;
        }
        this.editCompanyForm.setValue({

            idColorUser: this.currentCustomer.idcolorUser,

            socialReason: this.currentCustomer.socialReason,
            address: this.currentCustomer.address,
            postalCode: this.currentCustomer.postalCode,
            city: this.currentCustomer.city,
            country: tmpCountry,

            ctc: this.currentCustomer.ctcName,
            idCtc: this.currentCustomer.idCtc,

            businessCode: this.currentCustomer.businessCode,
            customerNumber: this.currentCustomer.mrpAccount,
            customerCode: this.currentCustomer.customerCode,
            compteTresor: this.currentCustomer.compteTresor,
            haveScale: this.currentCustomer.haveScale,
            paintBrand: this.currentCustomer.paintBrand,

            siren: this.currentCustomer.siren,
            tva: this.currentCustomer.tva

        });

        this.editCompanyForm.updateValueAndValidity();

        this.getRegions(false, 'edit', false);
        this.hideOtherCustomer('edit');
        this.emailExists = false;
        this.errorMsgMail = false;

        this.loadCtcOfDrCustomer("edit", "initEdit");

        if (this.languageChangeSub != null) {
            this.languageChangeSub.unsubscribe();
            this.languageChangeSub = null;
        }
        if (this.statsGetLastConnectionSub != null) {
            this.statsGetLastConnectionSub.unsubscribe();
            this.statsGetLastConnectionSub = null;
        }

        this.getClientsByCompany = this.apiServices.getClientsByCompany(customer.mail).subscribe(data => {

            /*----------------------------------------------------------------------------------------------------*/console.log(data);

            if (data) {
                this.editCustomersSource = null;
                this.editCustomersLst = data;
                if (this.editCustomersLst.length > 0) {
                    this.editCustomersSource = new MatTableDataSource(this.editCustomersLst.slice());
                }
            }
            if (this.getClientsByCompany != null) this.getClientsByCompany.unsubscribe();
        }, error => {
            console.log(error);
            if (this.getClientsByCompany != null) this.getClientsByCompany.unsubscribe();
        });

        this.displayModal('edit');
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    showEditUserEditModal(customer: IColorUserV1) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function showEditUserEditModal");
        this.openEditCustomerModal = true;

        //this.haveMailPrincipal = (customer.mail) ? true : false;
        this.changeMailPrincipal = customer.mail;
        this.haveChangeMailPrincipal = false;

        this.currentCustomer = customer;

        this.editCustomerForm.setValue({
            email: this.currentCustomer.mail,
            name: this.currentCustomer.name,
            firstName: this.currentCustomer.firstname,
            mobile: this.currentCustomer.mobilePhone,
            phone: this.currentCustomer.phone,
            language: this.currentCustomer.language,
            isAdminIVC: this.currentCustomer.isAdminIVC,
            isAdminIVL: this.currentCustomer.isAdminIVL,

            socialReason: this.editCompanyForm.controls['socialReason'].value,
            address: this.editCompanyForm.controls['address'].value,
            postalCode: this.editCompanyForm.controls['postalCode'].value,
            city: this.editCompanyForm.controls['city'].value,
            country: this.editCompanyForm.controls['country'].value,
            ctc: this.editCompanyForm.controls['ctc'].value,
            idCtc: this.editCompanyForm.controls['idCtc'].value,
            businessCode: this.editCompanyForm.controls['businessCode'].value,
            customerNumber: this.editCompanyForm.controls['customerNumber'].value,
            customerCode: this.editCompanyForm.controls['customerCode'].value,
            compteTresor: this.editCompanyForm.controls['compteTresor'].value,
            haveScale: this.editCompanyForm.controls['haveScale'].value,
            paintBrand: this.editCompanyForm.controls['paintBrand'].value,
            siren: this.editCompanyForm.controls['siren'].value,
            tva: this.editCompanyForm.controls['tva'].value

        });

        this.refreshLastConnectionDate(this.currentCustomer.mail);

        this.languageChangeSub = this.translateService.onLangChange.subscribe(() => {
            this.refreshLastConnectionDate(this.currentCustomer.mail);
        });

        this.displayModal('editCustomer');

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    showAddUserEditModal() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function showAddUserEditModal");
        this.openEditAddCustomerModal = true;
        this.displayModal('editAddCustomer');
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param mail
     */
    refreshLastConnectionDate(mail: string) {
        let language = this.storage.get("actualLanguage");
        if (language == "" || language == null)
            language = "fr";

        this.statsGetLastConnectionSub = this.apiServices.statsGetLastConnection(mail, language, moment().utcOffset() / 60).subscribe(data => {
            this.lastConnectionDate = data;
            if (this.statsGetLastConnectionSub != null) this.statsGetLastConnectionSub.unsubscribe();
        },
            error => {
                this.lastConnectionDate = "";
                if (this.statsGetLastConnectionSub != null) this.statsGetLastConnectionSub.unsubscribe();
            });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * commun
     * @param mail
     * @param type
     */
    checkMail(mail: string, type: string, type2: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function checkMail");
        if (type == 'editCustomer') {
            this.haveChangeMailPrincipal = (mail != this.changeMailPrincipal);
        }
        this.emailExists = false;
        this.hideOtherCustomer(type2);
        this.otherCustomer = new IColorUserV1();
        this.checkMailSub = this.apiServices.checkMail(mail, type == "editAddCustomer" ? 0 : this.currentCustomer.idcolorUser).subscribe(data => {
            if (data) {
                this.emailExists = true;
                this.otherCustomer = data;
            }
            if (type != "editCustomer" && type != "editAddCustomer")
                this.getRegions(false, type2, false);
        }, error => {
            console.log(error);
            if (this.checkMailSub != null) this.checkMailSub.unsubscribe();
        });
        this.errorMsgMail = this.customerEmailForm.valid ? false : true;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    showOtherCustomer(type: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function showOtherCustomer");
        this.otherCustomerForm.setValue({
            name: this.otherCustomer.name,
            firstName: this.otherCustomer.firstname,
            mobile: this.otherCustomer.mobilePhone,
            phone: this.otherCustomer.phone,
            socialReason: this.otherCustomer.socialReason,
            address: this.otherCustomer.address,
            postalCode: this.otherCustomer.postalCode,
            city: this.otherCustomer.city,
            country: this.otherCustomer.country,
            language: this.otherCustomer.language,

            isAdminIVC: this.otherCustomer.isAdminIVC,
            isAdminIVL: this.otherCustomer.isAdminIVL,
            ctc: this.otherCustomer.ctcName,
            idCtc: this.otherCustomer.idCtc,

            businessCode: this.otherCustomer.businessCode,
            customerNumber: this.otherCustomer.mrpAccount,
            customerCode: this.otherCustomer.customerCode,
            compteTresor: this.otherCustomer.compteTresor,

            siren: this.otherCustomer.siren,
            tva: this.otherCustomer.tva

        });
        if (this.otherCustomerForm.value.country && (this.otherCustomerForm.value.country.toLowerCase() == "france" || this.otherCustomerForm.value.country.toLowerCase() == "spain")) {
            this.mprRenaultOther = true;
            this.otherCustomerForm.controls['businessCode'].setValidators([Validators.required]);
        }
        else {
            this.mprRenaultOther = false;
            this.otherCustomerForm.controls['businessCode'].setValidators([]);
        }
        this.otherCustomerForm.controls['businessCode'].updateValueAndValidity();
        this.editCompanyForm.controls['businessCode'].updateValueAndValidity();

        switch (type) {
            case ('new'):
                this.showOther = true;
                break;
            case ('edit'):
                this.showOtherEdit = true;
                break;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    hideOtherCustomer(type: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function hideOtherCustomer");
        this.otherCustomerForm.reset();
        switch (type) {
            case ('new'):
                this.showOther = false;
                break;
            case ('edit'):
                this.showOtherEdit = false;
                break;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    saveOtherCustomer(type: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function saveOtherCustomer");
        var mailForm;
        switch (type) {
            case ('new'):
                mailForm = this.customerEmailForm;
                break;
            case ('edit'):
                mailForm = this.editCustomerForm;
                break;
        }

        this.otherCustomer.mail = mailForm.value.email;
        this.otherCustomer.socialReason = this.otherCustomerForm.value.socialReason;
        this.otherCustomer.address = this.otherCustomerForm.value.address;
        this.otherCustomer.city = this.otherCustomerForm.value.city;
        this.otherCustomer.postalCode = this.otherCustomerForm.value.postalCode;
        this.otherCustomer.country = this.countries.find(c => c.name.toLowerCase() == this.otherCustomerForm.value.country.toLowerCase() || c.vo.toLowerCase() == this.otherCustomerForm.value.country.toLowerCase()).name;

        this.otherCustomer.name = this.otherCustomerForm.value.name;
        this.otherCustomer.firstname = this.otherCustomerForm.value.firstName;
        this.otherCustomer.mobilePhone = this.otherCustomerForm.value.mobile;
        this.otherCustomer.phone = this.otherCustomerForm.value.phone;
        this.otherCustomer.language = this.otherCustomerForm.value.language;

        this.otherCustomer.ctcName = this.otherCustomerForm.value.ctc;
        this.otherCustomer.idCtc = this.otherCustomerForm.value.idCtc;

        this.otherCustomer.businessCode = this.otherCustomerForm.value.businessCode;
        this.otherCustomer.customerCode = this.otherCustomerForm.value.customerCode;
        this.otherCustomer.mrpAccount = this.otherCustomerForm.value.customerNumber;
        this.otherCustomer.compteTresor = this.otherCustomerForm.value.compteTresor;

        this.otherCustomer.siren = this.otherCustomerForm.value.siren;
        this.otherCustomer.tva = this.otherCustomerForm.value.tva;

        if (this.otherCustomerForm.status == 'VALID') {
            this.newCustomer = false;
            this.sendID(this.otherCustomer, type);
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    initCurrentCustomer(type: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function initCurrentCustomer");
        var email;
        var companyForm;
        var companyCountry;
        var customerForm;
        switch (type) {
            case ('new'):
                if (this.customerSelected != null && this.customerSelected != 'new') {
                    email = this.customerSelected.mail;
                    this.currentCustomer.idcolorUser = this.customerSelected.idcolorUser;
                }
                else {
                    email = this.customerEmailForm.value.email;
                }
                if (this.isNewCompany == false && this.dataCompanySelected == this.companySelected) // données récupérées
                {
                    companyForm = this.companySelected;
                    companyCountry = this.companySelected.country;
                }
                else // données saisies
                {
                    companyForm = this.companyForm.value;
                    companyCountry = this.companyForm.controls['country'].value;
                }
                customerForm = this.customerForm;
                break;
            //case ('edit'):
            //    email = this.editCompanyForm.value.email;
            //    companyForm = this.editCompanyForm.value;
            //    companyCountry = this.editCompanyForm.controls['country'].value;
            //    customerForm = this.editCompanyForm;
            //    break;
            case ('editCustomer'):
                email = this.editCustomerForm.value.email;

                this.editCustomerForm.patchValue({socialReason: this.editCompanyForm.controls['socialReason'].value});
                this.editCustomerForm.patchValue({address: this.editCompanyForm.controls['address'].value});
                this.editCustomerForm.patchValue({postalCode: this.editCompanyForm.controls['postalCode'].value});
                this.editCustomerForm.patchValue({city: this.editCompanyForm.controls['city'].value});
                this.editCustomerForm.patchValue({country: this.editCompanyForm.controls['country'].value});
                this.editCustomerForm.patchValue({ctc: this.editCompanyForm.controls['ctc'].value});
                this.editCustomerForm.patchValue({idCtc: this.editCompanyForm.controls['idCtc'].value});
                this.editCustomerForm.patchValue({businessCode: this.editCompanyForm.controls['businessCode'].value});
                this.editCustomerForm.patchValue({customerNumber: this.editCompanyForm.controls['customerNumber'].value});
                this.editCustomerForm.patchValue({customerCode: this.editCompanyForm.controls['customerCode'].value});
                this.editCustomerForm.patchValue({compteTresor: this.editCompanyForm.controls['compteTresor'].value});
                this.editCustomerForm.patchValue({haveScale: this.editCompanyForm.controls['haveScale'].value});
                this.editCustomerForm.patchValue({paintBrand: this.editCompanyForm.controls['paintBrand'].value});
                this.editCustomerForm.patchValue({siren: this.editCompanyForm.controls['siren'].value});
                this.editCustomerForm.patchValue({ tva: this.editCompanyForm.controls['tva'].value });

                companyForm = this.editCustomerForm.value;
                companyCountry = this.editCompanyForm.controls['country'].value;
                customerForm = this.editCustomerForm;
                break;
            case ('editAddCustomer'):
                email = this.addCustomerForm.value.email;

                this.addCustomerForm.patchValue({ socialReason: this.editCompanyForm.controls['socialReason'].value });
                this.addCustomerForm.patchValue({address: this.editCompanyForm.controls['address'].value});
                this.addCustomerForm.patchValue({postalCode: this.editCompanyForm.controls['postalCode'].value});
                this.addCustomerForm.patchValue({city: this.editCompanyForm.controls['city'].value});
                this.addCustomerForm.patchValue({country: this.editCompanyForm.controls['country'].value});
                this.addCustomerForm.patchValue({ctc: this.editCompanyForm.controls['ctc'].value});
                this.addCustomerForm.patchValue({idCtc: this.editCompanyForm.controls['idCtc'].value});
                this.addCustomerForm.patchValue({businessCode: this.editCompanyForm.controls['businessCode'].value});
                this.addCustomerForm.patchValue({customerNumber: this.editCompanyForm.controls['customerNumber'].value});
                this.addCustomerForm.patchValue({customerCode: this.editCompanyForm.controls['customerCode'].value});
                this.addCustomerForm.patchValue({compteTresor: this.editCompanyForm.controls['compteTresor'].value});
                this.addCustomerForm.patchValue({haveScale: this.editCompanyForm.controls['haveScale'].value});
                this.addCustomerForm.patchValue({paintBrand: this.editCompanyForm.controls['paintBrand'].value});
                this.addCustomerForm.patchValue({siren: this.editCompanyForm.controls['siren'].value});
                this.addCustomerForm.patchValue({ tva: this.editCompanyForm.controls['tva'].value });

                companyForm = this.addCustomerForm.value;
                companyCountry = this.editCompanyForm.controls['country'].value;
                customerForm = this.addCustomerForm;
                break;
        }
        /*----------------------------------------------------------------------------------------------------*/console.log("customerForm", customerForm);

        this.currentCustomer.mail = email;
        this.currentCustomer.socialReason = companyForm.socialReason;
        this.currentCustomer.address = companyForm.address;
        this.currentCustomer.city = companyForm.city;
        this.currentCustomer.postalCode = companyForm.postalCode;
        this.currentCustomer.country = this.countries.find(c => c.name.toLowerCase() == companyCountry.toLowerCase() || c.vo.toLowerCase() == companyCountry.toLowerCase()).name;

        this.currentCustomer.name = customerForm.value.name;
        this.currentCustomer.firstname = customerForm.value.firstName;
        this.currentCustomer.mobilePhone = customerForm.value.mobile;
        this.currentCustomer.phone = customerForm.value.phone;
        this.currentCustomer.language = customerForm.value.language;

        this.currentCustomer.isAdminIVC = customerForm.value.isAdminIVC ? customerForm.value.isAdminIVC : false;
        this.currentCustomer.isAdminIVL = customerForm.value.isAdminIVL ? customerForm.value.isAdminIVL : false;
        this.currentCustomer.ctcName = customerForm.value.ctc;
        this.currentCustomer.idCtc = customerForm.value.idCtc;

        this.currentCustomer.businessCode = customerForm.value.businessCode;
        this.currentCustomer.customerCode = customerForm.value.customerCode;
        this.currentCustomer.mrpAccount = customerForm.value.customerNumber;
        this.currentCustomer.compteTresor = customerForm.value.compteTresor;

        this.currentCustomer.siren = type == "new" ? companyForm.siren : customerForm.value.siren;
        this.currentCustomer.tva = type == "new" ? companyForm.tva : customerForm.value.tva;

        var valueHaveScale = ((customerForm.value.haveScale == false || customerForm.value.haveScale == null) ? 2 : customerForm.value.haveScale);
        this.currentCustomer.haveScale = valueHaveScale;
        this.currentCustomer.paintBrand = customerForm.value.paintBrand;
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    saveCompany(type: string) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function saveCompany");
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.editCompanyForm", this.editCompanyForm);

        var form = this.editCompanyForm;
        if (form.status == 'VALID') {

            this.editCurrentCompany = new IColorUserV1();
            this.editCurrentCompany.idcolorUser = this.editCompanyForm.controls['idColorUser'].value;
            this.editCurrentCompany.socialReason = this.editCompanyForm.controls['socialReason'].value;
            this.editCurrentCompany.address = this.editCompanyForm.controls['address'].value;
            this.editCurrentCompany.postalCode = this.editCompanyForm.controls['postalCode'].value;
            this.editCurrentCompany.city = this.editCompanyForm.controls['city'].value;
            this.editCurrentCompany.country = this.editCompanyForm.controls['country'].value;
            this.editCurrentCompany.ctcName = this.editCompanyForm.controls['ctc'].value;
            this.editCurrentCompany.idCtc = this.editCompanyForm.controls['idCtc'].value;
            this.editCurrentCompany.businessCode = this.editCompanyForm.controls['businessCode'].value;
            this.editCurrentCompany.mrpAccount = this.editCompanyForm.controls['customerNumber'].value;
            this.editCurrentCompany.customerCode = this.editCompanyForm.controls['customerCode'].value;
            this.editCurrentCompany.compteTresor = this.editCompanyForm.controls['compteTresor'].value;
            this.editCurrentCompany.haveScale = this.editCompanyForm.controls['haveScale'].value;
            this.editCurrentCompany.paintBrand = this.editCompanyForm.controls['paintBrand'].value;
            this.editCurrentCompany.siren = this.editCompanyForm.controls['siren'].value;
            this.editCurrentCompany.tva = this.editCompanyForm.controls['tva'].value;

            this.apiServices.saveEditCompanyColorUser(this.editCurrentCompany, "ManageColorUser", true).subscribe(data => {
                ///*----------------------------------------------------------------------------------------------------*/console.log("saveEditCompanyColorUser", data);
                ///*----------------------------------------------------------------------------------------------------*/console.log("this.customersLst", this.customersLst);
                var tmp = this.customersLst.find(c => c.idcolorUser == this.editCurrentCompany.idcolorUser);
                tmp.socialReason = this.editCompanyForm.controls['socialReason'].value;
                tmp.address = this.editCompanyForm.controls['address'].value;
                tmp.postalCode = this.editCompanyForm.controls['postalCode'].value;
                tmp.city = this.editCompanyForm.controls['city'].value;
                tmp.country = this.editCompanyForm.controls['country'].value;
                tmp.ctcName = this.editCompanyForm.controls['ctc'].value;
                tmp.idCtc = this.editCompanyForm.controls['idCtc'].value;
                tmp.businessCode = this.editCompanyForm.controls['businessCode'].value;
                tmp.mrpAccount = this.editCompanyForm.controls['customerNumber'].value;
                tmp.customerCode = this.editCompanyForm.controls['customerCode'].value;
                tmp.compteTresor = this.editCompanyForm.controls['compteTresor'].value;
                tmp.haveScale = this.editCompanyForm.controls['haveScale'].value;
                tmp.paintBrand = this.editCompanyForm.controls['paintBrand'].value;
                tmp.siren = this.editCompanyForm.controls['siren'].value;
                tmp.tva = this.editCompanyForm.controls['tva'].value;

                if (!data) {
                    console.error("erreur lors de l'enregistrement - cf log");
                }

            }, error => {
                console.log(error);
                if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
            });

        }
        else {
            /*----------------------------------------------------------------------------------------------------*/console.log("form invalide");
            form.markAllAsTouched();
        }

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    saveAndSendCustomer() {
        /*----------------------------------------------------------------------------------------------------*/console.log("function saveAndSendCustomer");
        this.initCurrentCustomer('new');
        /*----------------------------------------------------------------------------------------------------*/console.log("this.currentCustomer", this.currentCustomer);
        var customerForm = this.customerForm;
        customerForm = this.customerForm;
        if (customerForm.status == 'VALID') {
            this.sendID(this.currentCustomer, 'new');
        }
        //else {
        //    this.envoiMailModal = true;
        //    customerForm.markAllAsTouched();
        //}
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param customer
     * @param type
     */
    sendID(customer: IColorUserV1, type: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function sendID");
        /*----------------------------------------------------------------------------------------------------*/console.log("customer", customer);
        this.saveAndSendIDSub = this.apiServices.saveColorUserAndSendID(customer, this.newCustomer, type, ((type == "new") ? -1 : customer.idcolorUser), "ManageColorUser").subscribe(data => {

            /* <3 */
            var openPopUpRedirectAffactationMateriel = false;
            if ((this.currentCustomer.idcolorUser == 0 && !this.newCustomer) || this.newCustomer) {
                openPopUpRedirectAffactationMateriel = true;
                this.mailUser = this.currentCustomer.mail;
            }

            if (data == true) {
                this.mailCustomer = customer.mail;
                this.closeModal(type);
                this.validationModal = true;
                this.displayModal('validationModal');
            }

            if (this.isPreprod && !this.isAdminLacour) {
                this.infoPreprod = true;
                document.getElementById("infoPreprodModal").style.display = "block";
            }

            /* ajout ouverture pop-up redirection affectation materiel */
            if (openPopUpRedirectAffactationMateriel) {
                this.displayModal("redirectAffectationMaterielModal");
            }

        }, error => {
            console.log(error);
            if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    saveCustomer(type: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function saveCustomer");

        this.initCurrentCustomer(type);
        var form = (type == "new") ? this.customerForm : this.editCustomerForm;
        if (form.status == 'VALID') {
            this.saveSub = this.apiServices.saveColorUser(this.currentCustomer, this.newCustomer, type, ((type == "new") ? -1 : this.customerForm.value.idcolorUser), "ManageColorUser", true).subscribe(data => {

                var openPopUpRedirectAffactationMateriel = false;
                if ((this.currentCustomer.idcolorUser == 0 && !this.newCustomer) || this.newCustomer) {
                    openPopUpRedirectAffactationMateriel = true;
                    this.mailUser = this.currentCustomer.mail;
                }

                this.msgConfirmation = true;

                if (this.isPreprod && !this.isAdminLacour) {
                    this.infoPreprod = true;
                    document.getElementById("infoPreprodModal").style.display = "block";
                }

                if (openPopUpRedirectAffactationMateriel) {
                    this.displayModal("redirectAffectationMaterielModal");
                }

            }, error => {
                console.log(error);
                if (this.saveSub != null) this.saveSub.unsubscribe();
            });
        }
        else {
            form.markAllAsTouched();
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     */
    saveAndSendCustomerEdit(type: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function saveAndSendCustomerEdit");

        ///*----------------------------------------------------------------------------------------------------*/console.log(this.currentCustomer);

        this.haveChangeMailPrincipal = (this.editCustomerForm.value.email != this.changeMailPrincipal);
        this.emailExists = false;
        //this.hideOtherCustomer("edit");
        this.otherCustomer = new IColorUserV1();
        this.checkMailSub = this.apiServices.checkMail(type == 'editCustomer' ? this.editCustomerForm.value.email : this.addCustomerForm.value.email, this.currentCustomer.idcolorUser).subscribe(data => {
            if (data) {
                this.emailExists = true;
                this.otherCustomer = data;
            }
            else {

                this.initCurrentCustomer(type);
                var customerForm = type == 'editCustomer' ? this.editCustomerForm : this.addCustomerForm;
                /*----------------------------------------------------------------------------------------------------*/console.log("customerForm", customerForm);
                /*----------------------------------------------------------------------------------------------------*/console.log("customerForm.status", customerForm.status);
                if (customerForm.status == 'VALID') {

                    this.mailCustomer = this.currentCustomer.mail;
                    this.closeModal(type);
                    this.newCustomer = type == 'editAddCustomer';
                    this.envoiMailIdentifiant(type);

                    if (this.newCustomer) {
                        let customerAdded = JSON.parse(JSON.stringify(this.currentCustomer));
                        this.editCustomersLst.push(customerAdded);
                        if (this.editCustomersLst.length > 0) {
                            this.editCustomersSource = new MatTableDataSource(this.editCustomersLst.slice());
                        }
                    }
                    //this.openEnvoiMailIdentifiant(type);
                }
                //else {
                //    this.envoiMailModal = true;
                //    customerForm.markAllAsTouched();
                //}
            }
        }, error => {
            console.log(error);
            if (this.checkMailSub != null) this.checkMailSub.unsubscribe();
        });
        this.errorMsgMail = this.customerEmailForm.valid ? false : true;


    }

    ///* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    ///**
    // *
    // * */
    //openEnvoiMailIdentifiant(type: string) {
    //    /*----------------------------------------------------------------------------------------------------*/console.log("function openEnvoiMailIdentifiant");
    //    this.closeModal(type);
    //    //this.envoiMailModal = true;
    //    //this.haveMailPrincipal = (this.currentCustomer.mail) ? true : false;
    //    //this.checkBoxMailPrincipal = this.haveChangeMailPrincipal;
    //    //this.checkBoxMailSecondaire = false;
    //    this.mailCustomer = this.currentCustomer.mail;
    //    //this.displayModal('envoiMailModal');
    //    this.envoiMailIdentifiant();
    //}

    ///* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    ///**
    // * 
    // * @param check
    // */
    //envoiMailCheckMail(check: string) {
    //    /*----------------------------------------------------------------------------------------------------*/console.log("function envoiMailCheckMail");
    //    switch (check) {
    //        case 'principal':
    //            this.checkBoxMailPrincipal = !this.checkBoxMailPrincipal;
    //            break;
    //        case 'secondaire':
    //            this.checkBoxMailSecondaire = !this.checkBoxMailSecondaire;
    //            break;
    //    }
    //}

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    envoiMailIdentifiant(type: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function envoiMailIdentifiant");
        // si adresse mail coché
        //if (this.checkBoxMailPrincipal) {
        this.saveAndSendIDSub = this.apiServices.saveColorUserAndSendID(this.currentCustomer, this.newCustomer, type == 'editCustomer' ? 'edit' : "new", this.currentCustomer.idcolorUser, "ManageColorUser").subscribe(data => {

            var openPopUpRedirectAffactationMateriel = false;
            if ((this.currentCustomer.idcolorUser == 0 && !this.newCustomer) || this.newCustomer) {
                openPopUpRedirectAffactationMateriel = true;
                this.mailUser = this.currentCustomer.mail;
            }

            if (data == true) {
                this.mailCustomer = this.currentCustomer.mail;
                //this.closeModal('edit');
                //this.closeModal('envoiMailModal');
                this.validationModal = true;
                this.displayModal('validationModal');
            }

            if (this.isPreprod && !this.isAdminLacour) {
                this.infoPreprod = true;
                document.getElementById("infoPreprodModal").style.display = "block";
            }

            if (openPopUpRedirectAffactationMateriel && type == "editAddCustomer") {
                this.displayModal("redirectAffectationMaterielModal");
            }

        }, error => {
            console.log(error);
            if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
        });
        //}

        //if (!this.checkBoxMailPrincipal && !this.checkBoxMailSecondaire) {
        //    this.saveSub = this.apiServices.saveColorUser(this.currentCustomer, this.newCustomer, "edit", this.customerForm.value.idcolorUser, "ManageColorUser", true).subscribe(data => {
                
        //        this.validationModal = true;
        //        this.closeModal('edit');
        //        this.closeModal('envoiMailModal');

        //        if (this.isPreprod && !this.isAdminLacour) {
        //            this.infoPreprod = true;
        //            document.getElementById("infoPreprodModal").style.display = "block";
        //        }

        //    }, error => {
        //        console.log(error);
        //        if (this.saveSub != null) this.saveSub.unsubscribe();
        //    });
        //}
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * Check si le mail du client en cours de modification à été modifier
     * @param mail
     */
    inputMail(mail: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function inputMail");
        this.haveChangeMailPrincipal = (this.changeMailPrincipal != mail);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param sort
     * @param status
     */
    sort(sort: Sort, status: string) {
        /*----------------------------------------------------------------------------------------------------*/console.log("function sort");
        var data = this.customersLst;
        Constants.sortScale(sort, status, data)

        this.customersLst = data.slice();
        this.customersSource = new MatTableDataSource(this.customersLst);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    ngOnDestroy() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function ngOnDestroy");
        if (this.searchCustomersSub != null) this.searchCustomersSub.unsubscribe();
        if (this.checkMailSub != null) this.checkMailSub.unsubscribe();
        if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
        if (this.saveSub != null) this.saveSub.unsubscribe();
        if (this.regionsSub != null) this.regionsSub.unsubscribe();
        if (this.hiddeCustomerSub != null) this.hiddeCustomerSub.unsubscribe();
        if (this.deleteDateMailSub != null) this.deleteDateMailSub.unsubscribe();
        if (this.getCustomerSub != null) this.getCustomerSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.getSimilarCompanySub != null) this.getSimilarCompanySub.unsubscribe();
        if (this.getCustomersCompanySub != null) this.getCustomersCompanySub.unsubscribe();
        if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        if (this.autoCoSub != null) this.autoCoSub.unsubscribe();
        if (this.statsGetLastConnectionSub != null) this.statsGetLastConnectionSub.unsubscribe();
        if (this.languageChangeSub != null) this.languageChangeSub.unsubscribe();
        if (this.getLstCtcByCountrySub != null) this.getLstCtcByCountrySub.unsubscribe();
        if (this.getClientsByCompany != null) this.getClientsByCompany.unsubscribe();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param idColorUser
     */
    autoConnexion(idColorUser: number) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function autoConnexion");
        this.autoCoSub = this.apiServices.getAutoConnexionColorUser(idColorUser).subscribe(data => {
            this.router.navigate(['/home/' + data]);
        }, error => { if (this.autoCoSub != null) this.autoCoSub.unsubscribe(); });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    getCustomerByCtcId() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function getCustomerByCtcId");
        this.router.navigate(["historyaccount"]);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     * @param call
     */
    loadCtcOfDrCustomer(type: string, call: string) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function loadCtcOfDrCustomer");
        ///*----------------------------------------------------------------------------------------------------*/console.log("type", type);
        ///*----------------------------------------------------------------------------------------------------*/console.log("call", call);
        var customerForm;
        var country;
        switch (type) {
            case ('new'):
                switch (call) {
                    case ("region"):
                        this.customerForm.controls["businessCode"].setValue("");
                        this.customerForm.controls["ctc"].setValue("");
                        this.customerForm.controls["idCtc"].setValue("");
                        break;
                    case ("dr"):
                        this.customerForm.controls["ctc"].setValue("");
                        this.customerForm.controls["idCtc"].setValue("");
                        break;
                }
                country = this.companyForm.controls['country'].value;
                customerForm = this.customerForm;
                if (country && (country.toLowerCase() == "france" || country.toLowerCase() == "spain" || country.toLowerCase() == "united kingdom") && !customerForm.value.businessCode) {
                    this.customerForm.get('idCtc').disable();
                } else {
                    this.customerForm.get('idCtc').enable();
                }
                break;
            case ('edit'):
                switch (call) {
                    case ("region"):
                        this.editCompanyForm.controls["businessCode"].setValue("");
                        this.editCompanyForm.controls["ctc"].setValue("");
                        this.editCompanyForm.controls["idCtc"].setValue("");
                        break;
                    case ("dr"):
                        this.editCompanyForm.controls["ctc"].setValue("");
                        this.editCompanyForm.controls["idCtc"].setValue("");
                        break;
                }
                country = this.editCompanyForm.value.country;
                customerForm = this.editCompanyForm;
                if (country && (country.toLowerCase() == "france" || country.toLowerCase() == "spain" || country.toLowerCase() == "united kingdom") && !customerForm.value.businessCode) {
                    this.editCompanyForm.get('idCtc').disable();
                } else {
                    this.editCompanyForm.get('idCtc').enable();
                }
                break;
        }

        let pays = this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name;
        this.getCtcSub = this.apiServices.getLstCtcByCountryAndOrDR(pays, customerForm.value.businessCode).subscribe(data => {
            this.ctcsFiltered = data;
            if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.getCtcSub != null) this.getCtcSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    ctcSelected(type: string) {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function ctcSelected");
        switch (type) {
            case ('new'):
                this.customerForm.value.ctc = this.ctcsFiltered.find(c => c.idCtc == this.customerForm.value.idCtc).firstname + " " + this.ctcsFiltered.find(c => c.idCtc == this.customerForm.value.idCtc).name;
                break;
            case ('edit'):
                this.editCompanyForm.value.ctc = this.ctcsFiltered.find(c => c.idCtc == this.editCompanyForm.value.idCtc).firstname + " " + this.ctcsFiltered.find(c => c.idCtc == this.editCompanyForm.value.idCtc).name;
                break;
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param type
     */
    affectationMateriel() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function affectationMateriel");
        this.checkMailSub = this.apiServices.checkMail(this.mailUser, 0).subscribe(data => {
            if (data) {
                this.router.navigate(["/userClientForm/Client/" + data.idcolorUser]);
            } else {
                this.closeModal("redirectAffectationMaterielModal");
            }
        }, error => {
            console.log(error);
            if (this.checkMailSub != null) this.checkMailSub.unsubscribe();
        });

    }

}
